module.exports = __webpack_public_path__ + "img/baiteng.4781f86a.jpg";